<template>
  <div class="pt-15 pb-4 text-center">
<!--    <img-->
<!--      src="@/assets/mattrz_base_logo.png"-->
<!--      alt="mattrz_base"-->
<!--      :width="width"-->
<!--    />-->
    <img
      src="@/assets/b-cms-logo.png"
      alt="b-cms"
      style='max-height: 70px;'
    />
  </div>
</template>
<script>
export default {
  name: 'mattrz_base_logo',
  props: {
    width: {
      type: String,
      required: true
    }
  }
}
</script>
